<template>
  <span
    class="freestyle-action shape-action relative animation-toolbar-wrapper"
    :class="{
      'bg-secondary-15': isShowAnimationEditor,

    }"
    @click="showAnimationEditor"
    @mouseleave="hoverEvent"
    v-tooltip="tooltip"
  >
    <svg
      :class="{'disable': !isShowToolbarAnimation}"
      ref="selectedOption"

      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M15 2c-2.71 0-5.05 1.54-6.22 3.78a7.062 7.062 0 0 0-3 3A7.014 7.014 0 0 0 2 15c0 3.87 3.13 7 7 7c2.71 0 5.05-1.54 6.22-3.78a7.062 7.062 0 0 0 3-3A7.014 7.014 0 0 0 22 9c0-3.87-3.13-7-7-7M9 20a5.002 5.002 0 0 1-4-8c0 3.87 3.13 7 7 7c-.84.63-1.88 1-3 1m3-3a5.002 5.002 0 0 1-4-8c0 3.86 3.13 6.99 7 7c-.84.63-1.88 1-3 1m4.7-3.3c-.53.19-1.1.3-1.7.3c-2.76 0-5-2.24-5-5c0-.6.11-1.17.3-1.7c.53-.19 1.1-.3 1.7-.3c2.76 0 5 2.24 5 5c0 .6-.11 1.17-.3 1.7M19 12c0-3.86-3.13-6.99-7-7a5.002 5.002 0 0 1 7 7" />
    </svg>
  </span>
</template>
<script>

import { mapState } from 'vuex'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {

  computed: {
    ...mapState({
      selectingBlocks: (state) => state.selectingBlocks,
      isShowAnimationEditor: (state) => state.isShowAnimationEditor,
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    isShowToolbarAnimation() {
      return !!this.selectingBlocks.find((block) => {
        if (['Image', 'Emoji', 'RichText', 'Shape', 'Line'].includes(block.type)) {
          return true
        }
        return false
      })
    },
    tooltip() {
      return this.isShowToolbarAnimation ? this.$i18nPresenter.t('Animation') :
        this.$i18nPresenter.t('Animation. Select text, shapes or images to animate.')
    },

    blockData() {
      if (this.selectingBlocks && this.selectingBlocks.length > 0) {
        return this.selectingBlocks[0]
      }
      return null
    },

  },
  mounted() {
    // this.speed = this.blockData.content.speed || 0
  },
  methods: {
    hoverEvent() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Animation > Hover', null, null, {
        slideId: this.slideActive.id,
        presentationId: this.presentation.id,
        slideType: 'Content',

      })
    },

    showAnimationEditor() {
      if (!this.isShowToolbarAnimation) return
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Animation > Open menu', null, null, {
        slideId: this.slideActive.id,
        presentationId: this.presentation.id,
        slideType: 'Content',

      })
      this.$store.state.isShowAnimationEditor = !this.$store.state.isShowAnimationEditor
    },
  },

}
</script>
<style lang="scss" scoped>

.wrapper-check{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.disable{
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.4;
  &:hover{
    background: transparent;
  }
}
.freestyle-actions {
  position: absolute;
  padding-left: 16px;
  top: -100%;
  z-index: 4;
  width: 100%;
  height: 52px;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  left: 0;
  border-bottom: 1px solid #eee;

  .freestyle-action {

    cursor: pointer;
    display: flex;
    margin-right: 4px;
    color: #222;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 4px;

    &:hover {
      @apply bg-secondary-15;
    }

    &.__gif {
      margin-bottom: -0.75px;
    }

    &.emoji-action {
      position: relative;
    }
  }

}
</style>
